<main id="editor-page" class="flex" >

   <section>
    <div
    class="col-12"
    style="
      padding: 10px;
      position: fixed;
      z-index: 999999;
      border-bottom: 1px solid #e3e3f0;
      background-color: rgba(255, 255, 255, 1);
    "
  >
    <app-header></app-header>
  </div>
   </section>

 <section><div class="h-screen" id="editor">
  <div class="flex flex-col h-screen">
    <div
      class="container flex justify-between items-center"
      style="padding-bottom: 0.375rem;     flex-direction: column;"
    >
      <div class="border-none" #editorToolbar> </div>
      <div
        style="position: relative; 
        place-self: flex-end;"
        class="grid items-center switch-language-dropdown-container mt-5"
        sty
        *ngIf="editorState.words != 0"
      >
        <button
          (click)="toggleReportMenu($event)"
          class="switch-language-dropdown flex items-center gap-default justify-between mt-3"
       
        >
          <span class="flex gap-default items-center">
            <app-icons-free-tools
              *ngIf="!iconRequireReattachment"
              [name]="languages[selectedLanguage].icon"
            ></app-icons-free-tools>
            <!-- {{ languages[selectedLanguage].name }} -->
          </span>
          <app-icons name="chevronDown"></app-icons>
        </button>

        <ul
          style="display: none"
          class="language-menu p-0 mt-3"
          (click)="switchLanguage($event)"
        >
          <li
            [attr.data-language]="language"
            *ngFor="let language of Object.keys(languages)"
          >
            <app-icons-free-tools
              [name]="languages[language].icon"
            ></app-icons-free-tools>
            {{ languages[language].name }}
          </li>
        </ul>
      </div>
    </div>
    <div
      class=" flex-1 text-lg overflow-y-auto container scrollable" style="position: relative"
      [ngClass]="{ relative: !editorEnabled }"
    >
      <div #editor spellcheck="false"  ></div>
  <!-- popup card  -->
  <div
    class="popup"
    id="popup-Art"
    *ngIf="popupVisible"
    #popupContainer
    [ngStyle]="{ top: popupPosition.top, left: popupPosition.left }"
    style="background: white; border: 1px solid #d9e5e5 !important"
  >
    <div *ngIf="matchVisible" class="accept-dismiss">
      <div class="card-title" style="cursor: auto; font-size: 14px">
        <span class="corrected-text">{{ error_Type | titlecase }} </span>

        <button
          class="flex gap-sm"
          id="dismissBtn"
          (click)="handleDismiss($event)"
          [attr.data-target]="'err-' + Chk_ID + '-' + off_Set"
        >
          <span class="text-danger-main">
            <app-icons name="ignoreAll" />
          </span>

          <span>Dismiss</span>
        </button>
      </div>

      <div class="wrong-correct mt-3">
        <span class="error-text me-2" [class.no-error]="!popupSynonyms[0]">
          {{ wrong }}
        </span>

        <button
          style="border: none"
          class="corrcet-text me-2"
          *ngIf="popupSynonyms.length > 0"
          [attr.data-target]="'err-' + Chk_ID + '-' + off_Set"
          (click)="handleCorrection($event)"
          [attr.data-correction]="innerTextArray['value']"
        >
          {{ innerTextArray["value"] }}
        </button>
      </div>

      <div *ngIf="popupSynonyms.length > 1 || isValidSynonyms()">
        <p
          style="
            text-align: left;
            margin-top: 10px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(76, 83, 95, 1);
          "
        >
          Suggestion(s):
        </p>

        <div style="display: inline-flex">
          <button
            *ngFor="let replacement of innerTextArray | keyvalue"
            class="sugestion me-2"
            [attr.data-target]="'err-' + Chk_ID + '-' + off_Set"
            (click)="handleCorrection($event)"
            [attr.data-correction]="replacement.value"
          >
            {{ replacement.value }}
          </button>
        </div>
      </div>

      <div class="mt-2" style="display: flex; flex-direction: column">
        <span
          style="
            text-align: left;
            margin-top: 10px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(76, 83, 95, 1);
          "
        >
          Description:
        </span>
        <span
          style="
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: rgba(76, 83, 95, 1);
          "
          class="mt-1"
        >
          {{ message }}
        </span>
      </div>

      <ul id="corrections-container">
        <div class="error-card-footer">
          <button (click)="toggleReportMenu($event)">
            <app-icons name="toggleMenu"></app-icons>
          </button>

          <ul style="display: none" class="report-menu p-0">
            <li
              (click)="reportSuggestion($event)"
              [attr.id]="ID"
              [attr.data-rule]="id_Rule"
              [attr.data-text]="wrong"
              class="flex gap-default"
            >
              <app-icons name="reportSuggestion"></app-icons>

              Report Suggestion
            </li>
          </ul>
        </div>
      </ul>
    </div>

    <div *ngIf="modelVisble" class="accept-dismiss">
      <div class="card-title" style="cursor: auto; font-size: 12px">
        <span class="corrected-text">{{ gramar_model | titlecase }}</span>

        <div class="flex gap-default justify-end">
          <button
            class="flex gap-sm"
            (click)="handleDismiss($event, error_Type)"
            [attr.data-target]="'err-' + tread_ID"
          >
            <span class="text-danger-main">
              <app-icons name="ignoreAll" />
            </span>

            <span class="truncate">Dismiss</span>
          </button>
          <button
            class="flex gap-sm"
            [attr.data-model]="error_Type"
            [attr.data-target]="'err-' + tread_ID"
            [attr.data-correction]="JSON.stringify(replacementsArray)"
            [attr.data-correct]="correct_line"
            (click)="handleCorrection($event)"
          >
            <span class="text-primary-main">
              <app-icons name="correctAll" />
            </span>

            <span class="truncate">Accept</span>
          </button>
        </div>
      </div>

      <div class="sug_pp">
        <p
          style="
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: rgba(76, 83, 95, 1);
          "
          class="mt-2"
        >
          <!-- Suggestion(s): -->
        </p>

        <p
          class="error-text-paragraph overflow-y-auto"
          [innerHTML]="formatReplacementsArray(this.replacementsArray)"
        ></p>
      </div>
      <ul id="corrections-container">
        <div class="error-card-footer">
          <button (click)="toggleReportMenu($event)">
            <app-icons name="toggleMenu"></app-icons>
          </button>

          <ul style="display: none" class="report-menu p-0">
            <li
              (click)="reportSuggestion($event)"
              [attr.id]="ID"
              [attr.data-rule]="id_Rule"
              [attr.data-text]="wrong"
              class="flex gap-default"
            >
              <app-icons name="reportSuggestion"></app-icons>

              Report Suggestion
            </li>
          </ul>
        </div>
      </ul>
    </div>
  </div>
  <!-- popup card  -->
      <section
        class="container absolute inset-0 p-base pt-4 mt-5"
        [ngClass]="{ 'd-none': !(!editorEnabled && !editorState.words) }"
        (click)="renderEditor()"
        style="cursor: text"
      >
        <h4 class="mb-3">Type or paste (Ctrl+V) your text here.</h4>
        <p>Or, upload a document.</p>
        <app-upload-file
        (uploadStarted)="onUploadStart()"
        (uploadFinished)="onUploadFinish()"
      ></app-upload-file>
      </section>
    </div>
    <div
      class="p-base flex  items-center container"
     
      style="display: flex; flex-direction: column"
    >
    <div class="progress-loader-div">
      <div class="progress-loader" *ngIf="loaderAlert"></div>
    </div>
      <ul
        class="list-style-none gap-default m-0 p-0 d-flex mb-2"
        id="editor-characters-count-list"
      >
        <li>Words: {{ f(editorState.words) }}</li>
        <li>&nbsp; | &nbsp;</li>
        <li>Characters: {{ f(editorState.characters) }}</li>
      </ul>
    
      <div class="flex items-center gap-default">
        <p
          class="text-left success-msg"
          *ngIf="got_recpatcha"
          [ngStyle]="{
            color: color,
            'background-color': '#f8d7da',
            padding: '2px'
          }"
        >
          <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
          {{ recaptcha_message }}
        </p>
        <div *ngIf="captchaVisible" class="captcha-modal-overlay">
          <div class="captcha-modal">
            <div
              id="recaptcha-container"
              class="recaptcha-container"
              data-size="compact"
              data-theme="light"
            ></div>
          </div>
        </div>
        <button
          class="check-grammar-btn text-lg"
          
          [ngClass]="{
            'check-grammar-btn-loading':
              editorState.state === 'loading' ||
              editorState.grammarStatus === 'checking'
          }"
          (click)="
          editorState.characters === 0
            ? invokeModal($event)
            : handleButtonClick()
        "
          [disabled]="
            editorState.state === 'loading' ||
            editorState.grammarStatus === 'checking'
          "
          [attr.data-target]="'empty-content-modal'"
        >
      

          {{
            editorState.state === "loading" ||
            editorState.grammarStatus === "checking"
              ? "Checking"
              : "Check Grammar"
          }}
        </button>
        <ul class="list-style-none flex gap-default m-0 p-0">
          <li>
            <button class="btn-outline has-tooltip btn-width" (click)="clearEditor()" 
            *ngIf=" editorState.characters " >
              <app-icons name="clearIconTabView" />

              <span class="tooltip-content tooltip-top">Clear</span>
            </button>
          </li>
        </ul>
       
      </div>
    </div>
  </div>
</div></section>

  



  <!-- code for validation  -->
  <div
    *ngIf="error"
    class="backdrop"
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1000;
    "
  ></div>

  <div
    *ngIf="error"
    class="content-div"
    style="
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 290px;
      height: 300px;
      background-color:#ffffff;
    z-index: 1010;
    border-radius: 4px;
    border: 1px solid #ffffff;
    "
  >
  <div class="text-center" >
    <img src="/assets/images/paraphrasing tool/alert.svg" class="mt-3"/>

    <div style="display: flex; align-items: center; justify-content: center; height: 100px;">
      <p
        class="error mt-3 text-center"
        style="font-size: 28px; font-weight: 400; line-height: 33.89px"
      >
        {{ errorAlerts }}
      </p>
    </div>

    <button class=" check-grammar-btn" (click)="closeErrorDiv()">   Dismiss</button>
  </div>
  </div>

  <div
    *ngIf="success"
    class="backdrop"
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1000;
    "
  ></div>

  <div
    *ngIf="success"
    class="content-div"
    style="
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 290px;
      height: 410px;
      background-color: white;
      z-index: 1010;
      border-radius: 4px;
      border: 1px solid white;
    "
  >
    <div class="text-center" style="margin-top: 16%">
      <img src="/assets/images/paraphrasing tool/success.svg" />

      <p
        class="error mt-4"
        style="font-size: 28px; font-weight: 500; line-height: 33.89px"
      >
        {{ successAlert }}
      </p>

      <button class="mt-4 butn-alert" (click)="closeErrorDiv()">Ok</button>
    </div>
  </div>
  <!-- code for validation  -->

     <!-- empty quill  -->
     <app-modal parent="empty-content-modal">
      <modal-content>
        <section class="text-center grid justify-center">
          <h3>Enter at least 1 word.</h3>
  
          <p>Please enter at least 1 word to proceed.</p>
  
          <div>
            <button
              class="check-grammar-btn w-unset"
              (click)="dismissModal($event)"
              style="max-width: unset !important"
            >
              Dismiss
            </button>
          </div>
        </section>
      </modal-content>
    </app-modal>
     <!-- empty quill  -->
</main>
